import {AddNewSelectControlInterface} from '../../interfaces';

import {SelectControl} from './select-control';

export class AddNewSelectControl extends SelectControl {
    public addNewText: string;
    public disableAddNew: boolean;

    constructor(data: AddNewSelectControlInterface) {
        super(data);

        this.addNewText = data.addNewText;
        this.disableAddNew = !data.disableAddNew ? false : data.disableAddNew;
    }
}
